/**
 * Labstep
 *
 * @module
 * @desc Header for sharelink for Signin Screen
 */

import { Header } from 'labstep-web/core/Header';
import { SubHeader } from 'labstep-web/core/SubHeader';
import type React from 'react';
import type { IShareLinkHeaderProps } from './types';

export const ShareLinkHeader: React.FC<IShareLinkHeaderProps> = ({
  shareLink,
  sign,
}) => {
  return (
    <div>
      <SubHeader>{`You have been invited to ${
        shareLink.organization || shareLink.group ? 'join' : 'view'
      }...`}</SubHeader>
      <Header>{shareLink.entity.displayName}</Header>
      <SubHeader>
        {sign && `sign ${sign} to view this content.`}
      </SubHeader>
      <br />
    </div>
  );
};
